import { Form } from '../../interfaces';
import { formOverride } from '../../helpers';
import { checkboxField } from '../../models';

export const termsAndConditionsForm = (name: string, title: string, overrides: any = {}): Form =>
  formOverride(
    {
      name,
      fieldType: 'form',
      state: {
        title,
        open: false,
      },
      fields: [
        checkboxField('accept', 'Accept Terms and Conditions?', true, {
          valuePropName: 'value',
          toDataModelFn(value, dataModel) {
            Object.assign(dataModel, value);
          },
          fromDataModelFn(dataModel, formModel) {
            formModel.accept = dataModel;
          },
        }),
      ],
    },
    overrides
  );
